<div class="view-tutorial">
  <div class="container">
    <div class="view-video">
      <div class="vdo-content embed-responsive embed-responsive-16by9">
        <iframe
          class="embed-responsive-item"
          [src]="getLink() | safe: 'resourceUrl'"
          frameborder="0"
          allowfullscreen=""
          width="560"
          height="315"
        >
        </iframe>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="view-detail">
      <h1 class="title">{{ currentTutorial.title }}</h1>

      <div class="director" *ngIf="currentTutorial.director === 'FlowAccount'">
        <div class="director-img">
          <picture>
            <source srcset="https://flowaccountcdn.com/assets/images/FlowAccount_Team.jpg" type="image/webp" />
            <source srcset="https://flowaccountcdn.com/assets/images/FlowAccount_Team.jpg" type="image/jpeg" />
            <img
              src="https://flowaccountcdn.com/assets/images/FlowAccount_Team.jpg"
              width="100%"
              class="img-director"
              alt="FlowAccount Tutorial Course Director"
            />
          </picture>
        </div>
        <div class="director-name">
          FlowAccount Academy
          <div>โฟลว์แอคเคาท์ อะคาเดมี่</div>
        </div>
      </div>

      <div class="director" *ngIf="currentTutorial.director === 'Tanai'">
        <div class="director-img">
          <picture>
            <source srcset="https://flowaccountcdn.com/assets/images/K_Tanai3_120.jpg" type="image/webp" />
            <source srcset="https://flowaccountcdn.com/assets/images/K_Tanai3_120.jpg" type="image/jpeg" />
            <img
              src="https://flowaccountcdn.com/assets/images/K_Tanai3_120.jpg"
              width="100%"
              class="img-director"
              alt="FlowAccount Tutorial Course Director"
            />
          </picture>
        </div>
        <div class="director-name">
          คุณธนัย นพคุณ
          <br />FlowAccount Course Director
        </div>
      </div>

      <ng-container *ngIf="!isTutorialVideo2021">
        <div [innerHTML]="currentDescription"></div>
      </ng-container>

      <ng-container *ngIf="isTutorialVideo2021">
        <!-- description 1 -->
        <div *ngIf="currentTutorial.description_1">
          <p [innerHTML]="currentTutorial.description_1"></p>
        </div>
        <!-- description 2 -->
        <div *ngIf="currentTutorial.description_2">
          <p [innerHTML]="currentTutorial.description_2"></p>
        </div>
        <!-- description 3 -->
        <div *ngIf="currentTutorial.description_3">
          <p [innerHTML]="currentTutorial.description_3"></p>
        </div>
        <!-- description 4 -->
        <div *ngIf="currentTutorial.description_4">
          <p [innerHTML]="currentTutorial.description_4"></p>
        </div>
      </ng-container>
    </div>
  </div>
</div>
